import { type CstNodeLocation } from 'chevrotain';

// An error with a diagram that is suitable for display to the user.
class DiagramError extends Error {
  // If available, the location in the input where the error occurred.
  location: CstNodeLocation | undefined;

  constructor(
    message: string,
    location: CstNodeLocation | undefined = undefined
  ) {
    super(message);
    this.location = location;
  }

  equals(other: DiagramError): boolean {
    return (
      this.message === other.message &&
      this.location?.startColumn === other.location?.startColumn &&
      this.location?.startLine === other.location?.startLine &&
      this.location?.startOffset === other.location?.startOffset &&
      this.location?.endColumn === other.location?.endColumn &&
      this.location?.endLine === other.location?.endLine &&
      this.location?.endOffset === other.location?.endOffset
    );
  }
}

export default DiagramError;
